var map = {
	"./gameplay-chainspin-xxlarge.webp": [
		95169,
		95169
	],
	"./gameplay-chokwin-xxlarge.webp": [
		3856,
		3856
	],
	"./gameplay-gannar-xxlarge.webp": [
		8350,
		8350
	],
	"./gameplay-luckykingbet-xxlarge.webp": [
		96835,
		96835
	],
	"./gameplay-mars-br-xxlarge.webp": [
		88411,
		88411
	],
	"./gameplay-mars-es-xxlarge.webp": [
		90203,
		90203
	],
	"./gameplay-mars-mx-xxlarge.webp": [
		41377,
		41377
	],
	"./gameplay-mars-pt-xxlarge.webp": [
		41510,
		41510
	],
	"./gameplay-mars-ru-xxlarge.webp": [
		77854,
		77854
	],
	"./gameplay-mars-th-xxlarge.webp": [
		51113,
		51113
	],
	"./gameplay-mars-xxlarge.webp": [
		40393,
		40393
	],
	"./gameplay-novero-xxlarge.webp": [
		14945,
		14945
	],
	"./gameplay-rollblock-xxlarge.webp": [
		81459,
		81459
	],
	"./gameplay-zenginsin-xxlarge.webp": [
		36519,
		36519
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 30340;
module.exports = webpackAsyncContext;